import { DivisiResponse } from "../../../../models/Divisi";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function DownloadKandidatFile(KANDIDAT_ID: number) {
  const res = await ApiClient.get(
    `/DownloadKandidat?KANDIDAT_ID=${KANDIDAT_ID}`,
    { responseType: "arraybuffer" }
  );
  return res;
}

export const useDownloadKandidatFile = mutationWrapper(DownloadKandidatFile);
